import { SvgIconProps } from "@mui/material";
import { ComponentType, forwardRef } from "react";

import { FormFieldLayout } from "../layouts/form-field-layout";

import { InputError } from "./input-error";
import { InputLabel } from "./input-label";
import { SelectInput } from "./select-input";
import { InputErrorStyleProps } from "./styles/input-error.styles";
import { InputLabelStyleProps } from "./styles/input-label.styles";
import { InputWrapperStyleProps } from "./styles/input-wrapper.styles";
import { SelectInputStyleProps } from "./styles/select-input.styles";

interface FormSelectProps {
  name: string;
  label: string;
  required?: boolean;
  error?: string;
  isValid?: boolean;
  placeholder?: string;
  children: React.ReactNode;
  dataCy?: string;
  disabled?: boolean;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  component?: ComponentType<any>;
  rightIcon?: React.ComponentType<SvgIconProps>;
  styles?: {
    wrapper?: InputWrapperStyleProps;
    error?: InputErrorStyleProps;
    label?: InputLabelStyleProps;
    select?: SelectInputStyleProps;
    layout?: {
      className?: string;
    };
  };
}

export const FormSelect = forwardRef<HTMLSelectElement, FormSelectProps>(
  (
    {
      name,
      label,
      required,
      error,
      isValid,
      placeholder,
      children,
      dataCy,
      disabled,
      value,
      onChange,
      rightIcon,
      styles,
      component: SelectComponent = SelectInput,
    },
    ref,
  ) => {
    return (
      <FormFieldLayout className={styles?.layout?.className}>
        <InputLabel
          htmlFor={name}
          label={label}
          required={required}
          styles={styles?.label}
        />
        <SelectComponent
          ref={ref}
          name={name}
          error={error}
          isValid={isValid}
          placeholder={placeholder}
          dataCy={dataCy}
          disabled={disabled}
          value={value}
          onChange={onChange}
          rightIcon={rightIcon}
          wrapperStyles={styles?.wrapper}
          styles={styles?.select}
        >
          {children}
        </SelectComponent>
        {error && <InputError error={error} styles={styles?.error} />}
      </FormFieldLayout>
    );
  },
);

FormSelect.displayName = "FormSelect";
